import { inject } from '@angular/core';
import { ActivatedRouteSnapshot, CanActivateFn, Router, UrlTree } from '@angular/router';
import { map } from 'rxjs';
import { UnpaidPaymentsAccessService } from './unpaid-payments-access.service';
import { UNPAID_HUB_PRODUCTS } from './unpaid-payments-hub-products.config';
import { UnpaidPaymentsHubOverviewService } from './unpaid-payments-hub-overview.service';

const overviewUrlTree = (router: Router, route: ActivatedRouteSnapshot): UrlTree => {
  const segments = route.pathFromRoot
    .flatMap((snapshot) => snapshot.url.map((segment) => segment.path))
    .filter(Boolean);

  const unpaidIdx = segments.lastIndexOf('unpaid-payments');
  if (unpaidIdx >= 0) {
    return router.createUrlTree(['/', ...segments.slice(0, unpaidIdx + 1), 'overview']);
  }

  return router.createUrlTree(['/app/prism/unpaid-payments/overview']);
};

export const unpaidPaymentsProductAccessGuard: CanActivateFn = (route) => {
  const accessService = inject(UnpaidPaymentsAccessService);
  const hubOverviewService = inject(UnpaidPaymentsHubOverviewService);
  const router = inject(Router);

  const segment = route.routeConfig?.path ?? '';
  const productKey = accessService.productKeyForRouteSegment(segment);
  if (!productKey) {
    return true;
  }

  if (accessService.isProbed(productKey)) {
    return accessService.hasAccess(productKey) ? true : overviewUrlTree(router, route);
  }

  const product = UNPAID_HUB_PRODUCTS.find((item) => item.key === productKey);
  if (!product) {
    return overviewUrlTree(router, route);
  }

  return hubOverviewService.loadProductCard(product).pipe(
    map(() => (accessService.hasAccess(productKey) ? true : overviewUrlTree(router, route)))
  );
};
